module.exports = __webpack_public_path__ + "img/number2.2e1b83a9.jpg";